import { useParams, useNavigate } from "react-router-dom";
import "./../../assets/css/mentor/MentorDetail/Mentordetail.css";
import React, { useState } from "react";
import {
  Calendar,
  Clock,
  Star,
  Award,
  MessageCircle,
  Video,
  CheckCircle,
  ArrowLeft,
  Users,
  BookOpen,
} from "lucide-react";

// All mentors data
const allMentors = [
  {
    id: 1,
    name: "Mam Tabinda",
    role: "Senior Web Developer",
    expertise: ["React", "Node.js", "JavaScript", "Full Stack Development"],
    students: 250,
    courses: 8,
    rating: 4.9,
    email: "sarah.j@techmentor.com",
    avatar:
      "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop",
    location: "Gujranwala",
    company: "TechMentor Hub",
    bio: "Expert in frontend and backend development with 10 years experience. Passionate about teaching and helping students master modern web technologies.",
    bannerColor: "#781c2e",
    sessions: [
      { id: 1, title: "React Basics", duration: "1 hr", price: "6000 Rs" },
      {
        id: 2,
        title: "Node.js Deep Dive",
        duration: "2 hrs",
        price: "5000 Rs",
      },
    ],
    stats: { minutes: 3200, sessions: 8 },
    reviews: [
      {
        name: "Ahmed Ali",
        rating: 5,
        text: "Mam Tabinda is an excellent teacher! Her React course helped me land my first job.",
        date: "1 week ago",
      },
      {
        name: "Fatima Khan",
        rating: 5,
        text: "Very knowledgeable and patient. The Node.js deep dive was worth every penny!",
        date: "2 weeks ago",
      },
      {
        name: "Hassan Raza",
        rating: 5,
        text: "Best web development mentor in Karachi. Highly recommended!",
        date: "3 weeks ago",
      },
    ],
    achievements: [
      "10+ Years Development Experience",
      "250+ Students Mentored",
      "Full Stack Expert",
      "React & Node.js Specialist",
    ],
    languages: ["English", "Urdu"],
  },
  {
    id: 2,
    name: "Mam Anum",
    role: "Full Stack Architect",
    expertise: ["MERN Stack", "MongoDB", "Express", "React", "Node.js"],
    students: 320,
    courses: 12,
    rating: 5.0,
    email: "m.chen@techmentor.com",
    avatar:
      "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&h=400&fit=crop",
    location: "Gujranwala",
    company: "TechMentor Hub",
    bio: "Full stack expert helping students build scalable apps. Specialized in MERN stack with 12+ years of industry experience.",
    bannerColor: "#781c2e",
    sessions: [
      { id: 1, title: "MERN Basics", duration: "1 hr", price: "5000 Rs" },
      {
        id: 2,
        title: "Advanced MongoDB",
        duration: "1.5 hrs",
        price: "6000 Rs",
      },
    ],
    stats: { minutes: 1500, sessions: 60 },
    reviews: [
      {
        name: "Zain Malik",
        rating: 5,
        text: "Outstanding mentor! The MERN stack course was comprehensive and practical.",
        date: "5 days ago",
      },
      {
        name: "Ayesha Tariq",
        rating: 5,
        text: "Mam Anum's teaching style is amazing. I built my first full stack app!",
        date: "1 week ago",
      },
    ],
    achievements: [
      "12+ Years MERN Experience",
      "320+ Students Mentored",
      "Full Stack Architect",
      "MongoDB Certified Developer",
    ],
    languages: ["English", "Urdu", "Punjabi"],
  },

  {
    id: 3,
    name: "Mam Maheen",
    role: "Frontend Specialist",
    expertise: ["HTML", "CSS", "JavaScript", "React", "UI/UX Design"],
    students: 180,
    courses: 6,
    rating: 4.8,
    email: "maheen@techmentor.com",
    avatar: "/src/assets/images/maheen.jpg",
    location: "Lahore",
    bio: "Frontend specialist with strong command on UI/UX and responsive design.",
    stats: {
      minutes: 2800,
      sessions: 6,
    },
    sessions: [
      { id: 1, title: "HTML & CSS Mastery", duration: "1.5 hrs", price: "$18" },
      {
        id: 2,
        title: "React Frontend Basics",
        duration: "2 hrs",
        price: "$30",
      },
    ],
    achievements: [
      "8+ Years Frontend Experience",
      "180+ Students Mentored",
      "UI/UX Design Specialist",
    ],
  },
  {
    id: 4,
    name: "Mam Javeria",
    role: "Backend Specialist",
    expertise: [
      "Python",
      "Django",
      "REST APIs",
      "Database Design",
      "Server-side Development",
    ],
    students: 150,
    courses: 5,
    rating: 4.7,
    email: "javeria@techmentor.com",
    avatar: "/src/assets/images/javeria.jpg",
    location: "Karachi",
    bio: "Backend specialist with expertise in Python, Django, and scalable server-side applications.",
    stats: {
      minutes: 3200,
      sessions: 7,
    },
    sessions: [
      {
        id: 1,
        title: "Python Programming Fundamentals",
        duration: "2 hrs",
        price: "$20",
      },
      {
        id: 2,
        title: "Django for Beginners",
        duration: "2.5 hrs",
        price: "$35",
      },
    ],
    achievements: [
      "7+ Years Backend Experience",
      "150+ Students Mentored",
      "Python & Django Specialist",
    ],
  },
  {
    id: 5,
    name: "Mam Mahoor",
    role: "Mobile & Frontend Specialist",
    expertise: [
      "React Native",
      "React.js",
      "Bootstrap",
      "UI/UX Design",
      "Responsive Design",
    ],
    students: 200,
    courses: 7,
    rating: 4.9,
    email: "mahoor@techmentor.com",
    avatar: "/src/assets/images/mahoor.jpg",
    location: "Islamabad",
    bio: "Specialist in React Native and React.js with strong skills in building responsive and intuitive UI/UX.",
    stats: {
      minutes: 3500,
      sessions: 8,
    },
    sessions: [
      {
        id: 1,
        title: "React.js Advanced Concepts",
        duration: "2 hrs",
        price: "$25",
      },
      {
        id: 2,
        title: "React Native Mobile Apps",
        duration: "2.5 hrs",
        price: "$40",
      },
    ],
    achievements: [
      "6+ Years Frontend & Mobile Experience",
      "200+ Students Mentored",
      "React & Bootstrap Specialist",
    ],
  },
];

export default function MentorDetailPageDynamic() {
  const [selectedMentorId, setSelectedMentorId] = useState(1);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedSlot, setSelectedSlot] = useState(null);

  const mentor = allMentors.find((m) => m.id === selectedMentorId);

  // Sample available dates and slots
  const availableDates = [
    {
      date: "2025-12-23",
      day: "Mon",
      slots: ["09:00 AM", "10:00 AM", "02:00 PM", "04:00 PM"],
    },
    {
      date: "2025-12-24",
      day: "Tue",
      slots: ["09:00 AM", "11:00 AM", "03:00 PM"],
    },
    {
      date: "2025-12-25",
      day: "Wed",
      slots: ["10:00 AM", "01:00 PM", "05:00 PM"],
    },
    {
      date: "2025-12-26",
      day: "Thu",
      slots: ["09:00 AM", "02:00 PM", "04:00 PM"],
    },
    { date: "2025-12-27", day: "Fri", slots: ["11:00 AM", "03:00 PM"] },
  ];

  const handleBooking = () => {
    if (selectedDate && selectedSlot) {
      alert(
        `Booking confirmed with ${mentor.name} for ${selectedDate.day}, ${selectedDate.date} at ${selectedSlot}`,
      );
    }
  };

  const changeMentor = (mentorId) => {
    setSelectedMentorId(mentorId);
    setSelectedDate(null);
    setSelectedSlot(null);
  };

  return (
    <div
      style={{
        backgroundColor: "#f9f6ee",
        minHeight: "100vh",
        fontFamily: "system-ui, -apple-system, sans-serif",
      }}
    >
      {/* Header */}
      <header
        style={{
          backgroundColor: "#781c2e",
          color: "#f9f6ee",
          padding: "1rem 2rem",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        }}
      >
        <div
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
            <ArrowLeft size={24} style={{ cursor: "pointer" }} />
            <h1 style={{ fontSize: "1.5rem", fontWeight: "700", margin: 0 }}>
              Tech Mentor Hub
            </h1>
          </div>

          {/* Mentor Selector */}
          <select
            value={selectedMentorId}
            onChange={(e) => changeMentor(Number(e.target.value))}
            style={{
              padding: "0.5rem 1rem",
              borderRadius: "6px",
              border: "2px solid #f9f6ee",
              backgroundColor: "#781c2e",
              color: "#f9f6ee",
              fontSize: "1rem",
              fontWeight: "600",
              cursor: "pointer",
            }}
          >
            {allMentors.map((m) => (
              <option key={m.id} value={m.id}>
                {m.name}
              </option>
            ))}
          </select>
        </div>
      </header>

      {/* Main Content */}
      <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "2rem" }}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "2rem",
          }}
        >
          {/* Left Column - Mentor Info */}
          <div>
            {/* Profile Card */}
            <div
              style={{
                backgroundColor: "white",
                borderRadius: "12px",
                padding: "2rem",
                marginBottom: "1.5rem",
                boxShadow: "0 2px 8px rgba(120,28,46,0.1)",
              }}
            >
              <div
                style={{
                  display: "flex",
                  gap: "1.5rem",
                  marginBottom: "1.5rem",
                }}
              >
                <img
                  src={mentor.avatar}
                  alt={mentor.name}
                  style={{
                    width: "120px",
                    height: "120px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: `4px solid ${mentor.bannerColor}`,
                  }}
                />
                <div style={{ flex: 1 }}>
                  <h2
                    style={{
                      fontSize: "1.75rem",
                      fontWeight: "700",
                      color: "#781c2e",
                      margin: "0 0 0.5rem 0",
                    }}
                  >
                    {mentor.name}
                  </h2>
                  <p
                    style={{
                      color: "#666",
                      fontSize: "1rem",
                      margin: "0 0 0.5rem 0",
                    }}
                  >
                    {mentor.role}
                  </p>
                  <p
                    style={{
                      color: "#999",
                      fontSize: "0.9rem",
                      margin: "0 0 1rem 0",
                    }}
                  >
                    at {mentor.company}
                  </p>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.5rem",
                    }}
                  >
                    <Star size={20} fill="#FFD700" color="#FFD700" />
                    <span style={{ fontWeight: "600", color: "#781c2e" }}>
                      {mentor.rating}
                    </span>
                    <span style={{ color: "#999" }}>
                      ({mentor.students} students)
                    </span>
                  </div>
                </div>
              </div>

              {/* Stats */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(3, 1fr)",
                  gap: "1rem",
                  padding: "1rem 0",
                  borderTop: "1px solid #eee",
                  borderBottom: "1px solid #eee",
                  margin: "1rem 0",
                }}
              >
                <div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.5rem",
                      color: mentor.bannerColor,
                      marginBottom: "0.25rem",
                    }}
                  >
                    <Clock size={18} />
                    <span style={{ fontWeight: "600", fontSize: "1.1rem" }}>
                      {mentor.stats.minutes}
                    </span>
                  </div>
                  <span style={{ color: "#999", fontSize: "0.8rem" }}>
                    Total minutes
                  </span>
                </div>
                <div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.5rem",
                      color: mentor.bannerColor,
                      marginBottom: "0.25rem",
                    }}
                  >
                    <BookOpen size={18} />
                    <span style={{ fontWeight: "600", fontSize: "1.1rem" }}>
                      {mentor.courses}
                    </span>
                  </div>
                  <span style={{ color: "#999", fontSize: "0.8rem" }}>
                    Courses
                  </span>
                </div>
                <div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.5rem",
                      color: mentor.bannerColor,
                      marginBottom: "0.25rem",
                    }}
                  >
                    <Users size={18} />
                    <span style={{ fontWeight: "600", fontSize: "1.1rem" }}>
                      {mentor.students}
                    </span>
                  </div>
                  <span style={{ color: "#999", fontSize: "0.8rem" }}>
                    Students
                  </span>
                </div>
              </div>

              {/* Expertise Tags */}
              <div style={{ marginTop: "1.5rem" }}>
                <h3
                  style={{
                    fontSize: "1rem",
                    fontWeight: "600",
                    color: "#781c2e",
                    marginBottom: "0.75rem",
                  }}
                >
                  Expertise
                </h3>
                <div
                  style={{ display: "flex", flexWrap: "wrap", gap: "0.5rem" }}
                >
                  {mentor.expertise.map((skill, idx) => (
                    <span
                      key={idx}
                      style={{
                        backgroundColor: "#f9f6ee",
                        color: mentor.bannerColor,
                        padding: "0.4rem 0.8rem",
                        borderRadius: "20px",
                        fontSize: "0.85rem",
                        border: `1px solid ${mentor.bannerColor}`,
                      }}
                    >
                      {skill}
                    </span>
                  ))}
                </div>
              </div>
            </div>

            {/* About Section */}
            <div
              style={{
                backgroundColor: "white",
                borderRadius: "12px",
                padding: "2rem",
                marginBottom: "1.5rem",
                boxShadow: "0 2px 8px rgba(120,28,46,0.1)",
              }}
            >
              <h3
                style={{
                  fontSize: "1.25rem",
                  fontWeight: "600",
                  color: "#781c2e",
                  marginBottom: "1rem",
                }}
              >
                About
              </h3>
              <p
                style={{
                  color: "#666",
                  lineHeight: "1.7",
                  fontSize: "0.95rem",
                }}
              >
                {mentor.bio}
              </p>

              <div style={{ marginTop: "1.5rem" }}>
                <h4
                  style={{
                    fontSize: "1rem",
                    fontWeight: "600",
                    color: "#781c2e",
                    marginBottom: "0.75rem",
                  }}
                >
                  Languages
                </h4>
                <p style={{ color: "#666" }}>{mentor.languages.join(", ")}</p>
              </div>

              <div style={{ marginTop: "1.5rem" }}>
                <h4
                  style={{
                    fontSize: "1rem",
                    fontWeight: "600",
                    color: "#781c2e",
                    marginBottom: "0.75rem",
                  }}
                >
                  Location
                </h4>
                <p style={{ color: "#666" }}>{mentor.location}</p>
              </div>

              <div style={{ marginTop: "1.5rem" }}>
                <h4
                  style={{
                    fontSize: "1rem",
                    fontWeight: "600",
                    color: "#781c2e",
                    marginBottom: "0.75rem",
                  }}
                >
                  Contact
                </h4>
                <p style={{ color: "#666" }}>{mentor.email}</p>
              </div>
            </div>

            {/* Achievements */}
            <div
              style={{
                backgroundColor: "white",
                borderRadius: "12px",
                padding: "2rem",
                marginBottom: "1.5rem",
                boxShadow: "0 2px 8px rgba(120,28,46,0.1)",
              }}
            >
              <h3
                style={{
                  fontSize: "1.25rem",
                  fontWeight: "600",
                  color: "#781c2e",
                  marginBottom: "1rem",
                  display: "flex",
                  alignItems: "center",
                  gap: "0.5rem",
                }}
              >
                <Award size={24} />
                Achievements
              </h3>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "0.75rem",
                }}
              >
                {mentor.achievements.map((achievement, idx) => (
                  <div
                    key={idx}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.75rem",
                    }}
                  >
                    <CheckCircle size={18} color={mentor.bannerColor} />
                    <span style={{ color: "#666" }}>{achievement}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Reviews */}
            {mentor.reviews.length > 0 && (
              <div
                style={{
                  backgroundColor: "white",
                  borderRadius: "12px",
                  padding: "2rem",
                  boxShadow: "0 2px 8px rgba(120,28,46,0.1)",
                }}
              >
                <h3
                  style={{
                    fontSize: "1.25rem",
                    fontWeight: "600",
                    color: "#781c2e",
                    marginBottom: "1rem",
                  }}
                >
                  Reviews ({mentor.reviews.length})
                </h3>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "1.5rem",
                  }}
                >
                  {mentor.reviews.map((review, idx) => (
                    <div
                      key={idx}
                      style={{
                        borderBottom:
                          idx < mentor.reviews.length - 1
                            ? "1px solid #eee"
                            : "none",
                        paddingBottom: "1.5rem",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: "0.5rem",
                        }}
                      >
                        <span style={{ fontWeight: "600", color: "#781c2e" }}>
                          {review.name}
                        </span>
                        <span style={{ color: "#999", fontSize: "0.85rem" }}>
                          {review.date}
                        </span>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          gap: "0.25rem",
                          marginBottom: "0.5rem",
                        }}
                      >
                        {[...Array(review.rating)].map((_, i) => (
                          <Star
                            key={i}
                            size={14}
                            fill="#FFD700"
                            color="#FFD700"
                          />
                        ))}
                      </div>
                      <p
                        style={{
                          color: "#666",
                          fontSize: "0.9rem",
                          lineHeight: "1.6",
                        }}
                      >
                        {review.text}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* Right Column - Booking */}
          <div>
            <div style={{ position: "sticky", top: "2rem" }}>
              {/* Session Types */}
              <div
                style={{
                  backgroundColor: "white",
                  borderRadius: "12px",
                  padding: "2rem",
                  marginBottom: "1.5rem",
                  boxShadow: "0 2px 8px rgba(120,28,46,0.1)",
                }}
              >
                <h3
                  style={{
                    fontSize: "1.25rem",
                    fontWeight: "600",
                    color: "#781c2e",
                    marginBottom: "1rem",
                  }}
                >
                  Session Options
                </h3>
                {mentor.sessions.map((session, idx) => (
                  <div
                    key={idx}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "1rem",
                      marginBottom: "0.75rem",
                      border: `2px solid ${mentor.bannerColor}`,
                      borderRadius: "8px",
                      backgroundColor: "#f9f6ee",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.75rem",
                      }}
                    >
                      <Video size={20} color={mentor.bannerColor} />
                      <div>
                        <div style={{ fontWeight: "600", color: "#781c2e" }}>
                          {session.title}
                        </div>
                        <div style={{ fontSize: "0.85rem", color: "#666" }}>
                          {session.duration}
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        fontWeight: "700",
                        color: mentor.bannerColor,
                        fontSize: "1.1rem",
                      }}
                    >
                      {session.price}
                    </div>
                  </div>
                ))}
              </div>

              {/* Booking Calendar */}
              <div
                style={{
                  backgroundColor: "white",
                  borderRadius: "12px",
                  padding: "2rem",
                  boxShadow: "0 2px 8px rgba(120,28,46,0.1)",
                }}
              >
                <h3
                  style={{
                    fontSize: "1.25rem",
                    fontWeight: "600",
                    color: "#781c2e",
                    marginBottom: "1rem",
                    display: "flex",
                    alignItems: "center",
                    gap: "0.5rem",
                  }}
                >
                  <Calendar size={24} />
                  Book a Session
                </h3>

                {/* Date Selection */}
                <div style={{ marginBottom: "1.5rem" }}>
                  <h4
                    style={{
                      fontSize: "0.95rem",
                      fontWeight: "600",
                      color: "#666",
                      marginBottom: "0.75rem",
                    }}
                  >
                    Select Date
                  </h4>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "repeat(5, 1fr)",
                      gap: "0.5rem",
                    }}
                  >
                    {availableDates.map((dateObj, idx) => (
                      <button
                        key={idx}
                        onClick={() => {
                          setSelectedDate(dateObj);
                          setSelectedSlot(null);
                        }}
                        style={{
                          padding: "0.75rem 0.5rem",
                          border:
                            selectedDate?.date === dateObj.date
                              ? `2px solid ${mentor.bannerColor}`
                              : "1px solid #ddd",
                          borderRadius: "8px",
                          backgroundColor:
                            selectedDate?.date === dateObj.date
                              ? mentor.bannerColor
                              : "white",
                          color:
                            selectedDate?.date === dateObj.date
                              ? "#f9f6ee"
                              : "#666",
                          cursor: "pointer",
                          fontSize: "0.85rem",
                          fontWeight: "600",
                          textAlign: "center",
                          transition: "all 0.2s",
                        }}
                      >
                        <div>{dateObj.day}</div>
                        <div
                          style={{ fontSize: "0.75rem", marginTop: "0.25rem" }}
                        >
                          {dateObj.date.split("-")[2]}
                        </div>
                      </button>
                    ))}
                  </div>
                </div>

                {/* Time Slot Selection */}
                {selectedDate && (
                  <div style={{ marginBottom: "1.5rem" }}>
                    <h4
                      style={{
                        fontSize: "0.95rem",
                        fontWeight: "600",
                        color: "#666",
                        marginBottom: "0.75rem",
                      }}
                    >
                      Select Time
                    </h4>
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(2, 1fr)",
                        gap: "0.5rem",
                      }}
                    >
                      {selectedDate.slots.map((slot, idx) => (
                        <button
                          key={idx}
                          onClick={() => setSelectedSlot(slot)}
                          style={{
                            padding: "0.75rem",
                            border:
                              selectedSlot === slot
                                ? `2px solid ${mentor.bannerColor}`
                                : "1px solid #ddd",
                            borderRadius: "8px",
                            backgroundColor:
                              selectedSlot === slot
                                ? mentor.bannerColor
                                : "white",
                            color: selectedSlot === slot ? "#f9f6ee" : "#666",
                            cursor: "pointer",
                            fontSize: "0.9rem",
                            fontWeight: "600",
                            transition: "all 0.2s",
                          }}
                        >
                          {slot}
                        </button>
                      ))}
                    </div>
                  </div>
                )}

                {/* Booking Summary */}
                {selectedDate && selectedSlot && (
                  <div
                    style={{
                      backgroundColor: "#f9f6ee",
                      padding: "1rem",
                      borderRadius: "8px",
                      marginBottom: "1rem",
                      border: `1px solid ${mentor.bannerColor}`,
                    }}
                  >
                    <div
                      style={{
                        fontSize: "0.9rem",
                        color: "#666",
                        marginBottom: "0.5rem",
                      }}
                    >
                      Selected:
                    </div>
                    <div style={{ fontWeight: "600", color: "#781c2e" }}>
                      {selectedDate.day}, {selectedDate.date} at {selectedSlot}
                    </div>
                  </div>
                )}

                {/* Book Button */}
                <button
                  onClick={handleBooking}
                  disabled={!selectedDate || !selectedSlot}
                  style={{
                    width: "100%",
                    padding: "1rem",
                    backgroundColor:
                      selectedDate && selectedSlot
                        ? mentor.bannerColor
                        : "#ccc",
                    color: "#f9f6ee",
                    border: "none",
                    borderRadius: "8px",
                    fontSize: "1rem",
                    fontWeight: "700",
                    cursor:
                      selectedDate && selectedSlot ? "pointer" : "not-allowed",
                    transition: "all 0.3s",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "0.5rem",
                  }}
                >
                  <MessageCircle size={20} />
                  Confirm Booking with {mentor.name.split(" ")[1]}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
